import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabL as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabL = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const tutoringOnlyField = () => {
    const propertyName = pn<AprResponseModel>("tutoringOnly");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.tutoringOnly} {formatPercentTotal(props.data?.tutoringOnly, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const mentoringOnlyField = () => {
    const propertyName = pn<AprResponseModel>("mentoringOnly");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.mentoringOnly} {formatPercentTotal(props.data?.mentoringOnly, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const tutoringMentoringField = () => {
    const propertyName = pn<AprResponseModel>("tutoringMentoring");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.tutoringMentoring} {formatPercentTotal(props.data?.tutoringMentoring, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const neitherField = () => {
    const propertyName = pn<AprResponseModel>("neither");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.neither} {formatPercentTotal(props.data?.neither, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Competitive Preference Priorities</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {tutoringOnlyField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {mentoringOnlyField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {tutoringMentoringField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {neitherField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={9}>
            <PieChart id="pie-tab-l" 
            dataSource={props.data?.chartValues} 
            palette="Bright"
            title="Participants" width="100%"
            size={{ width: 1200, height: 700 }} // Increase chart size
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
          
        </Grid>
      </Stack>
    </Card>
  );
};
